import types from './types';

const feeWaiverManagementInitialState = {
    uploadingAppApiIntegration: false,
    uploadAppApiIntegrationCSVError: "",
    isSubmittedAppApiIntegrationCSV: false,
    uploadingSubscriptionOrganisation: false,
    uploadSubscriptionOrganisationCSVError: "",
    isSubmittedSubscriptionOrganisationCSV: false,
    integrationCSVData: null,
    downloadingIntegrationCSV: false,
    downloadIntegrationCSVError: "",
};

const reducerActions = {
    [types.UPLOAD_APP_API_INTEGRATION_CSV_PATCH_REQUEST]: (state, action) => ({
        ...state,
        uploadingAppApiIntegration: true,
        uploadAppApiIntegrationCSVError: "",
        isSubmittedAppApiIntegrationCSV: false,
    }),
    [types.UPLOAD_APP_API_INTEGRATION_CSV_PATCH_RECEIVE]: (state, action) => ({
        ...state,
        uploadingAppApiIntegration: false,
        uploadAppApiIntegrationCSVError: "",
        isSubmittedAppApiIntegrationCSV: true,
    }),
    [types.UPLOAD_APP_API_INTEGRATION_CSV_PATCH_ERROR]: (state, {response }) => ({
        ...state,
        uploadingAppApiIntegration: false,
        uploadAppApiIntegrationCSVError: response.message,
        isSubmittedAppApiIntegrationCSV: false,
    }),
    [types.UPLOAD_SUBSCRIBER_ORGANISATION_CSV_PATCH_REQUEST]: (state, action) => ({
        ...state,
        uploadingSubscriptionOrganisation: true,
        uploadSubscriptionOrganisationCSVError: "",
        isSubmittedSubscriptionOrganisationCSV: false,
    }),
    [types.UPLOAD_SUBSCRIBER_ORGANISATION_CSV_PATCH_RECEIVE]: (state, action) => ({
        ...state,
        uploadingSubscriptionOrganisation: false,
        uploadSubscriptionOrganisationCSVError: "",
        isSubmittedSubscriptionOrganisationCSV: true,
    }),
    [types.UPLOAD_SUBSCRIBER_ORGANISATION_CSV_PATCH_ERROR]: (state, {response}) => ({
        ...state,
        uploadingSubscriptionOrganisation: false,
        uploadSubscriptionOrganisationCSVError: response.message,
        isSubmittedSubscriptionOrganisationCSV: false,
    }),
    [types.DOWNLOAD_INTEGRATION_REPORT_CSV_GET_REQUEST]: (state) => ({
        ...state,
        downloadingIntegrationCSV: true,
        downloadIntegrationCSVError: "",
        integrationCSVData: null,
    }),
    [types.DOWNLOAD_INTEGRATION_REPORT_CSV_GET_RECEIVE]: (state, { response }) => ({
        ...state,
        downloadingIntegrationCSV: false,
        integrationCSVData: response,
        downloadIntegrationCSVError: "",
    }),
    [types.DOWNLOAD_INTEGRATION_REPORT_CSV_GET_ERROR]: (state, { response }) => ({
        ...state,
        downloadingIntegrationCSV: false,
        integrationCSVData: null,
        downloadIntegrationCSVError: response?.message || "Download failed",
    }),
    [types.RESET_ALL]: (state, action) => ({
        ...feeWaiverManagementInitialState
    })
}

const FeeWaiverManagementReducer = (state = feeWaiverManagementInitialState, action) => {
    return reducerActions[action.type] ? reducerActions[action.type](state, action) : state
}

export default FeeWaiverManagementReducer;